export default "/_next/static/images/6d02e57a47cd80a54dfcb85613101e81.png";